import { FC } from "react"

import { PointRule } from "types/tournament.types"

import { NumberInput } from "./NumberInput"

interface ActionFieldsProps {
  action: PointRule["then"]
  onChange: (key: string, val: any) => void
}

export const ActionFields: FC<ActionFieldsProps> = ({ action, onChange }) => {
  switch (action.type) {
    case "award_points":
    case "lose_points":
      return <NumberInput label="Points" value={action.amount} onChange={(v) => onChange("amount", v)} placeholder="e.g., 100" />

    case "award_bet_percentage":
    case "award_win_percentage":
    case "lose_percentage":
      return (
        <NumberInput
          label="Percentage (%)"
          value={action.percentage}
          onChange={(v) => onChange("percentage", v)}
          step={0.01}
          placeholder="e.g., 10"
        />
      )

    case "award_multiplier_bonus":
      return (
        <NumberInput
          label="Points per multiplier unit"
          value={action.amount}
          onChange={(v) => onChange("amount", v)}
          placeholder="e.g., 50"
        />
      )

    case "steal_points":
      return (
        <div className="grid grid-cols-2 gap-3">
          <NumberInput label="Points to steal" value={action.amount} onChange={(v) => onChange("amount", v)} placeholder="e.g., 10" />
          <NumberInput
            label="Target count"
            value={action.target_count}
            onChange={(v) => onChange("target_count", v)}
            placeholder="e.g., 3"
          />
        </div>
      )

    case "steal_percentage":
      return (
        <div className="grid grid-cols-2 gap-3">
          <NumberInput
            label="Steal percentage (%)"
            value={action.percentage}
            onChange={(v) => onChange("percentage", v)}
            step={0.01}
            placeholder="e.g., 5"
          />
          <NumberInput
            label="Target count"
            value={action.target_count}
            onChange={(v) => onChange("target_count", v)}
            placeholder="e.g., 3"
          />
        </div>
      )

    case "shield":
    case "point_lock":
      return (
        <NumberInput
          label="Duration (minutes)"
          value={action.duration_minutes}
          onChange={(v) => onChange("duration_minutes", v)}
          placeholder="e.g., 60"
        />
      )

    case "multiply_next_spins":
      return (
        <div className="grid grid-cols-2 gap-3">
          <NumberInput
            label="Multiplier"
            value={action.multiplier}
            onChange={(v) => onChange("multiplier", v)}
            step={0.1}
            placeholder="e.g., 2.0"
          />
          <NumberInput label="For N spins" value={action.spin_count} onChange={(v) => onChange("spin_count", v)} placeholder="e.g., 5" />
        </div>
      )

    case "multiply_for_duration":
      return (
        <div className="grid grid-cols-2 gap-3">
          <NumberInput
            label="Multiplier"
            value={action.multiplier}
            onChange={(v) => onChange("multiplier", v)}
            step={0.1}
            placeholder="e.g., 2.0"
          />
          <NumberInput
            label="Duration (minutes)"
            value={action.duration_minutes}
            onChange={(v) => onChange("duration_minutes", v)}
            placeholder="e.g., 30"
          />
        </div>
      )

    case "eliminate_all":
      return (
        <div className="grid grid-cols-2 gap-3">
          <NumberInput
            label="Reduction % per player"
            value={action.percentage}
            onChange={(v) => onChange("percentage", v)}
            step={1}
            placeholder="e.g., 10"
          />
          <NumberInput
            label="Min points to trigger"
            value={action.amount}
            onChange={(v) => onChange("amount", v)}
            placeholder="e.g., 100"
          />
        </div>
      )

    default:
      return null
  }
}
